import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/contact";

export const FloatingWhatsApp = () => (
  <a
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Me contacter sur WhatsApp"
    className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#10B981] text-ink flex items-center justify-center hover:scale-110 active:scale-95 transition-transform"
    style={{ boxShadow: "0 0 28px rgba(16,185,129,0.5)" }}
  >
    <MessageCircle size={24} />
  </a>
);
